export interface Product {
  id: string;
  name: string;
  description: string;
  specs: string[];
  image: string;
}

export interface Category {
  id: string;
  name: string;
  description: string;
  icon: string;
  products: Product[];
}

export const categories: Category[] = [
  {
    id: 'dram-chips',
    name: 'DRAM 芯片',
    description: '高性能动态随机存取存储芯片，覆盖DDR4、DDR5、LPDDR4X、LPDDR5X等全系列产品线，广泛应用于服务器、个人电脑、移动终端及消费电子领域。',
    icon: 'ri-cpu-line',
    products: [
      {
        id: 'ddr5-5600',
        name: 'DDR5 5600MT/s 存储芯片',
        description: '新一代DDR5架构，传输速率高达5600MT/s，单颗容量16Gb，采用1.1V低功耗设计。适用于高性能服务器、数据中心及AI计算平台，显著提升多任务处理效率与系统响应速度。',
        specs: ['16Gb 容量', '5600MT/s 速率', '1.1V 电压', 'FBGA 封装', '工作温度 0°C ~ 95°C'],
        image: 'https://readdy.ai/api/search-image?query=High%20tech%20DRAM%20DDR5%20memory%20chip%20on%20circuit%20board%20with%20gold%20contacts%2C%20clean%20white%20studio%20background%2C%20premium%20product%20photography%2C%20soft%20diffused%20lighting%2C%20minimalist%20composition%2C%20scientific%20precision%20aesthetic%2C%20macro%20detail%20of%20semiconductor%20silicon%20die%2C%20isometric%20angle%20showing%20BGA%20pins&width=600&height=600&seq=dram-ddr5-01&orientation=squarish',
      },
      {
        id: 'lpddr5x-8533',
        name: 'LPDDR5X 8533Mbps 低功耗芯片',
        description: '面向旗舰移动终端的超低功耗存储方案，速率高达8533Mbps，单颗容量12Gb。采用先进1.05V核心电压，支持动态频率调节技术，为AI手机与旗舰平板提供极致能效比。',
        specs: ['12Gb 容量', '8533Mbps 速率', '1.05V 电压', 'PoP 封装', '工作温度 -25°C ~ 85°C'],
        image: 'https://readdy.ai/api/search-image?query=LPDDR5X%20low%20power%20mobile%20DRAM%20memory%20chip%20on%20white%20minimalist%20background%2C%20compact%20semiconductor%20package%2C%20clean%20studio%20product%20photography%2C%20soft%20lighting%20with%20gentle%20shadows%2C%20premium%20tech%20aesthetic&width=600&height=600&seq=dram-lpddr5-02&orientation=squarish',
      },
      {
        id: 'ddr4-3200',
        name: 'DDR4 3200MT/s 存储芯片',
        description: '成熟稳定的DDR4架构存储方案，单颗容量8Gb/16Gb可选，3200MT/s稳定速率。广泛应用于企业级服务器、工控设备及消费级PC，具备优异的兼容性与可靠性。',
        specs: ['8Gb/16Gb 容量', '3200MT/s 速率', '1.2V 电压', 'FBGA 封装', '工作温度 0°C ~ 95°C'],
        image: 'https://readdy.ai/api/search-image?query=DDR4%20DRAM%20memory%20chip%20closeup%20on%20white%20surface%2C%20clean%20minimalist%20product%20photography%2C%20professional%20studio%20lighting%2C%20semiconductor%20detail%20with%20metallic%20pins%2C%20neutral%20background&width=600&height=600&seq=dram-ddr4-03&orientation=squarish',
      },
    ],
  },
  {
    id: 'memory-modules',
    name: '内存模组',
    description: '基于自研DRAM芯片打造的高性能内存模组产品，涵盖UDIMM、SODIMM、RDIMM等多种规格，满足从消费级到企业级的全场景内存需求。',
    icon: 'ri-stack-line',
    products: [
      {
        id: 'udimm-ddr5-32gb',
        name: 'DDR5 UDIMM 32GB 内存条',
        description: '桌面级DDR5内存模组，32GB大容量，5600MT/s高速传输。支持Intel XMP 3.0与AMD EXPO一键超频技术，内置PMIC电源管理芯片，为游戏玩家与内容创作者提供澎湃性能。',
        specs: ['32GB 容量', '5600MT/s 速率', '288-Pin UDIMM', 'PMIC 集成', '铝制散热片'],
        image: 'https://readdy.ai/api/search-image?query=DDR5%20UDIMM%20memory%20module%20with%20aluminum%20heatsink%20on%20white%20background%2C%20clean%20product%20photography%2C%20professional%20studio%20lighting%2C%20premium%20PC%20hardware%20aesthetic%2C%20minimalist%20composition&width=600&height=600&seq=mod-udimm-01&orientation=squarish',
      },
      {
        id: 'rdimm-ddr5-64gb',
        name: 'DDR5 RDIMM 64GB 服务器内存',
        description: '企业级服务器DDR5 RDIMM模组，64GB超大容量，支持ECC纠错与Registered缓冲技术。专为数据中心、云计算与AI训练集群打造，确保7×24小时稳定运行。',
        specs: ['64GB 容量', '5600MT/s 速率', '288-Pin RDIMM', 'ECC 支持', 'Registered 缓冲'],
        image: 'https://readdy.ai/api/search-image?query=DDR5%20RDIMM%20server%20memory%20module%20on%20white%20background%2C%20clean%20professional%20product%20photography%2C%20studio%20lighting%2C%20enterprise%20grade%20hardware%2C%20minimalist%20tech%20style&width=600&height=600&seq=mod-rdimm-02&orientation=squarish',
      },
      {
        id: 'sodimm-ddr5-16gb',
        name: 'DDR5 SODIMM 16GB 笔记本内存',
        description: '紧凑型DDR5 SODIMM模组，16GB容量，专为超薄笔记本与迷你PC设计。低功耗高性能，轻松应对多任务办公、编程开发与轻度创作场景。',
        specs: ['16GB 容量', '5600MT/s 速率', '262-Pin SODIMM', '1.1V 低功耗', '紧凑设计'],
        image: 'https://readdy.ai/api/search-image?query=DDR5%20SODIMM%20laptop%20memory%20module%20on%20white%20background%2C%20compact%20small%20form%20factor%2C%20clean%20studio%20product%20photography%2C%20professional%20lighting%2C%20minimalist%20composition&width=600&height=600&seq=mod-sodimm-03&orientation=squarish',
      },
    ],
  },
  {
    id: 'embedded-storage',
    name: '嵌入式存储',
    description: '面向物联网、汽车电子、工业控制等领域的嵌入式存储解决方案，提供eMMC、UFS等标准化产品及定制化存储设计服务。',
    icon: 'ri-hard-drive-line',
    products: [
      {
        id: 'emmc-512gb',
        name: 'eMMC 5.1 512GB 嵌入式存储',
        description: '符合JEDEC eMMC 5.1标准的嵌入式存储芯片，512GB大容量，顺序读取速度达310MB/s。广泛适用于智能电视、机顶盒、车载信息娱乐系统及工业平板等场景。',
        specs: ['512GB 容量', 'eMMC 5.1 标准', '310MB/s 读取', '153-Ball FBGA', '工规级可选'],
        image: 'https://readdy.ai/api/search-image?query=eMMC%20embedded%20storage%20chip%20on%20white%20background%2C%20clean%20minimalist%20product%20photography%2C%20professional%20studio%20lighting%2C%20compact%20semiconductor%20package%2C%20premium%20tech%20aesthetic&width=600&height=600&seq=emb-emmc-01&orientation=squarish',
      },
      {
        id: 'ufs-31-256gb',
        name: 'UFS 3.1 256GB 高速存储',
        description: 'UFS 3.1高速嵌入式存储方案，256GB容量，顺序读取高达2100MB/s。支持写入增强与深度睡眠低功耗模式，为高端智能终端提供旗舰级存储体验。',
        specs: ['256GB 容量', 'UFS 3.1 标准', '2100MB/s 读取', '153-Ball FBGA', '深度睡眠模式'],
        image: 'https://readdy.ai/api/search-image?query=UFS%20universal%20flash%20storage%20chip%20on%20white%20background%2C%20clean%20product%20photography%2C%20professional%20studio%20lighting%2C%20high%20speed%20storage%20semiconductor%2C%20minimalist%20composition&width=600&height=600&seq=emb-ufs-02&orientation=squarish',
      },
    ],
  },
  {
    id: 'solutions',
    name: '解决方案',
    description: '从芯片到系统的全链路存储解决方案，涵盖数据中心内存池化、AI推理加速缓存、汽车电子存储安全等前沿应用场景的定制化设计服务。',
    icon: 'ri-lightbulb-line',
    products: [
      {
        id: 'datacenter-cxl',
        name: '数据中心 CXL 内存池化方案',
        description: '基于CXL 2.0协议的内存池化解决方案，实现跨服务器节点的内存资源共享与弹性扩展。显著提升数据中心内存利用率，降低TCO达30%以上。',
        specs: ['CXL 2.0 协议', '内存池化架构', '弹性扩展', 'TCO 降低30%', '异构计算支持'],
        image: 'https://readdy.ai/api/search-image?query=CXL%20memory%20pooling%20data%20center%20architecture%20diagram%20on%20white%20background%2C%20clean%20tech%20illustration%20style%2C%20professional%20enterprise%20solution%20visualization%2C%20minimalist%20server%20infrastructure%20concept&width=600&height=600&seq=sol-cxl-01&orientation=squarish',
      },
      {
        id: 'automotive-storage',
        name: '汽车电子存储安全方案',
        description: '符合ISO 26262 ASIL-B功能安全等级的汽车级存储方案，支持 -40°C ~ 105°C宽温工作。为智能座舱、ADAS与自动驾驶域控制器提供安全可靠的数据存储基础。',
        specs: ['ISO 26262 ASIL-B', '-40°C ~ 105°C', '车规级认证', '数据完整性保护', 'AEC-Q100'],
        image: 'https://readdy.ai/api/search-image?query=Automotive%20grade%20storage%20chip%20in%20modern%20car%20electronics%20concept%2C%20clean%20white%20background%2C%20professional%20tech%20illustration%20style%2C%20ADAS%20autonomous%20driving%20storage%20solution%20visual&width=600&height=600&seq=sol-auto-02&orientation=squarish',
      },
    ],
  },
];